/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum GtoEntryPoint {
  HP = 'HP',
  JE = 'JE',
  QQ = 'QQ',
}

export const GTO_ENTRY_KEYS = {
  [GtoEntryPoint.HP]: {
    id: 'housePlanId',
    viewId: 'hpViewId',
    topId: 'hpTakeOffParamId',
  },
  [GtoEntryPoint.QQ]: {
    id: 'housePlanId',
    viewId: 'hpViewId',
    topId: 'hpTakeOffParamId',
  },
  [GtoEntryPoint.JE]: {
    id: 'jobId',
    viewId: 'jobViewId',
    topId: 'jobTakeOffParamId',
  },
};

export function getGtoEntryKey(entryPoint: GtoEntryPoint, type: string): string {
  return GTO_ENTRY_KEYS[entryPoint][type];
}
